import React, { Component } from 'react'
import { Link } from "react-router-dom"
import './footer.scss'
import ReactGA from 'react-ga';

class Footer extends Component {

    privacyClicked = () => {
        ReactGA.event({
            category: 'User',
            action: 'Privacy clicked'
        });
    }

    render() {
        return (
            <footer>
                <div>Copyright © {this.props.companyName} 2019-2020</div>
                <div>Registered in England &amp; Wales. 11836943 | VAT Registration No. 315851407</div>
                <div><Link id="privacy-policy-link" to="/privacy-policy" onClick={this.privacyClicked}>Privacy Policy</Link></div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js